(function () {
    'use strict';

    angular.module("imApp").factory("interBranchMultiService", ['$ihttp', function ($ihttp) {
        let service = {
            listMultiInterBranches: function (parms) {
                return $ihttp.post({
                    method: 789,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
